import React, { useEffect, useReducer, useState } from 'react';
import { Modal, Button } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { restaurantDashboardReservationTableSelector } from '../../DashboardSlice';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import CustomTableAssign from '../../../../shared/dashboard/custom-table-assign/CustomTableAssign';
import { sortBy } from 'lodash';

const AssignTable = (props) => {
  const { assignObj, handleClose, onAssignTable, order } = props;
  const allTables = useSelector(restaurantDashboardReservationTableSelector);
  const [unReservedTable, setUnReservedTable] = useState([]);
  const [unReservedTableLoader, setUnReservedTableLoader] = useState(false);

  let reservations = [],
    availableTables = [],
    current = [];
  allTables?.forEach((item) => {
    item?.reservations?.forEach((reservation) => {
      const reservedDate = reservation?.split('#').at(-3);
      const reservedFrom = reservation?.split('#').at(-1)?.split('-')[0];
      const reservedUntil = reservation?.split('#').at(-1)?.split('-')[1];
      order?.date === reservedDate &&
      ((order?.reserveFrom === reservedFrom && order?.reserveUntil === reservedUntil) ||
        (reservedFrom <= order?.reserveFrom && order?.reserveFrom < reservedUntil) ||
        (reservedFrom < order?.reserveUntil && order?.reserveUntil <= reservedUntil))
        ? (reservations = [...reservations, item])
        : (availableTables = [...availableTables, item]);
    });
  });

  availableTables = allTables?.filter((value) => !reservations?.includes(value));
  current = allTables
    ?.filter((value) => order?.tableNumbers?.includes(value?.tableNumber))
    ?.map((item) => ({ ...item, isSelected: true }));

  availableTables = sortBy([...current, ...availableTables], (item) => item?.tableNumber);

  function getUnReservedTable() {
    const currRevTable = [...allTables];
    const currUnReservedTable = [];

    currRevTable.forEach((tables) => {
      let currUnReservedTableNdx = -1;

      order.tableNumbers.forEach((x) => {
        if (x === tables.tableNumber) {
          const currentReserveTables = { ...tables };
          currentReserveTables.isSelected = true;
          currUnReservedTable.push(currentReserveTables);
        }
      });

      if (tables.reservations === null) {
        currUnReservedTable.push({ ...tables });
      } else {
        const reserveFrom = moment(order.reserveFrom, 'HH:mm');
        const reserveUntil = moment(order.reserveUntil, 'HH:mm');
        let isAvailable = true;
        tables.reservations.forEach((reservation) => {
          if (currUnReservedTable.length > 0) {
            currUnReservedTableNdx = currUnReservedTable.findIndex(
              (tablesList) => tablesList.tableNumber === tables.tableNumber,
            );
          }
          if (reservation.split('#')[2] === order?.date) {
            const getBothTime = reservation.split('#')[4];
            const startTime = moment(getBothTime.split('-')[0], 'HH:mm');
            const endTime = moment(getBothTime.split('-')[1], 'HH:mm');
            const isStartBetween = moment(reserveFrom, 'HH:mm').isBetween(startTime, endTime);
            const isEndBetween = moment(reserveUntil, 'HH:mm').isBetween(startTime, endTime);
            const isSame = moment(reserveFrom, 'HH:mm').isSame(startTime);
            if ((isStartBetween && isEndBetween) || isSame) {
              isAvailable = false;
            }
          }
        });
        if (currUnReservedTableNdx === -1 && isAvailable) {
          currUnReservedTable.push({ ...tables });
        }
      }
    });
    const tableNumbers = { ...formData.tableNumbers };
    tableNumbers.value = order.tableNumbers;
    setFormData({ tableNumbers });
    return currUnReservedTable;
  }

  useEffect(() => {
    setUnReservedTableLoader(true);
    if (allTables?.length > 0) {
      const unReservedTableList = getUnReservedTable();
      if (unReservedTableList.length === 0) setUnReservedTable([]);
      else {
        const currUnReservedTable = unReservedTableList.map((tables) => {
          if (!tables.isSelected) {
            tables.isSelected = false;
          }
          return { ...tables };
        });
        setUnReservedTable(currUnReservedTable);
      }
    } else setUnReservedTable([]);
    setUnReservedTableLoader(false);
  }, [allTables]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    tableNumbers: {
      value: [],
      fieldName: 'tableNumbers',
      errors: {},
      validations: ['required'],
    },
  });

  const onSubmit = (e) => {
    e.preventDefault();
    if (formData.tableNumbers.value.length > 0) return onAssignTable(formData.tableNumbers.value);
    return false;
  };

  const handleCheckbox = (e) => {
    const tableNumbers = { ...formData.tableNumbers };
    const currentReseveTables = [...tableNumbers.value];
    if (e.target.checked) currentReseveTables.push(e.target.value);
    else {
      const currIndex = currentReseveTables.indexOf(+e.target.value);
      if (currIndex > -1) currentReseveTables.splice(currIndex, 1);
    }
    tableNumbers.value = currentReseveTables;
    setFormData({ tableNumbers });
    const currentUnReservedTable = [...unReservedTable];
    currentUnReservedTable.map((tables) => {
      return {
        ...tables,
        isSelected: tables.tableNumber === e.target.value ? e.target.checked : false,
      };
    });
  };

  return (
    <Modal open={assignObj.status} onClose={handleClose}>
      <div className='assign-table-modal'>
        <p className='title'>Assign Table to {assignObj.name}</p>
        {unReservedTableLoader ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          <>
            <form onSubmit={onSubmit}>
              <div className='form-scroll scroll-styled table-card'>
                <div className='row col-md-12'>
                  {availableTables?.length > 0 ? (
                    <>
                      {availableTables?.map((val) => (
                        <div className='col-md-4' key={val.tableNumber}>
                          <CustomTableAssign
                            handleCheckbox={handleCheckbox}
                            checked={val.isSelected}
                            value={val.tableNumber}
                            capacity={val.capacity}
                            exposure={val.exposure}
                          />
                        </div>
                      ))}
                    </>
                  ) : (
                    <p> No Tables Available</p>
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-end pt-4'>
                <div>
                  <Button
                    variant='outlined'
                    color='secondary'
                    type='button'
                    className='mx-4'
                    onClick={() => handleClose()}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant='contained'
                    color='primary'
                    type='submit'
                    disabled={formData.tableNumbers.value.length > 0 ? false : true}
                  >
                    Assign Table
                  </Button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </Modal>
  );
};

export default AssignTable;
